import type { Transaction } from "@/apis/gql/types";
import {
  TableActionBarButton,
  TableActionBarRoot,
  TableActionBarRowsSelected,
} from "@/components/shared/data-table/action-bar";
import type { Table as TableType } from "@tanstack/react-table";
import { Link2 } from "lucide-react";
import { useTranslation } from "react-i18next";

type Props = {
  onMatch: () => Promise<void>;
  selectedInvoices: Record<string, boolean>;
  table: TableType<Transaction>;
};

export const TableActionBar = ({ onMatch, selectedInvoices, table }: Props) => {
  const { t } = useTranslation();

  const selectedTransactions = table
    .getFilteredSelectedRowModel()
    .rows.map((row) => row.original);

  async function handleMatch() {
    await onMatch();
  }

  if (selectedTransactions.length === 0) return null;

  return (
    <TableActionBarRoot className="gap-4">
      <TableActionBarRowsSelected table={table} />
      {selectedInvoices && Object.keys(selectedInvoices).length > 0 && (
        <div className="flex flex-row gap-2">
          <TableActionBarButton
            variant="outline"
            className="gap-2"
            onClick={handleMatch}
          >
            <Link2 className="w-4 h-4" />
            {t("transactions.actions.match")}
          </TableActionBarButton>
        </div>
      )}
    </TableActionBarRoot>
  );
};
